import { Position } from './position';
import { TrackerLockEvent } from './tracker-lock-event';

export class Tracker {
    id: number;
    idTracker: string;
    positions: Array<Position>;
    selected: boolean = true;
    detail: string;
    color: string;
    imei: string;
    customer_id: number;
    tracker_type:string;
    hasLock:boolean;
    isLocked:boolean;
    idLockEventPending: number;
    isUserCanLock: boolean = false;
    trackerLockEvents: Array<TrackerLockEvent>;

    constructor (id:number, idTracker:string, positions:Array<Position>, detail:string, color:string, tracker_type:string, customer_id:number) {
        this.id = id;
        this.idTracker = idTracker;
        this.positions = positions;
        this.detail = detail;
        this.color = color;
        this.tracker_type = tracker_type;
        this.customer_id = customer_id;
    }

    get fullName() {
        if (this.detail && this.idTracker) {
            return this.idTracker + ' (' + this.detail + ')';
        }
        else if (this.detail && !this.idTracker) {
            return this.detail;
        } else if (!this.detail && this.idTracker) {
            return this.idTracker;
        } else {
            return this.id + ' (veículo não informado)';
        }        

    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/tracker.ts